package amazon.lastmile.inject

import app.nestbridge.feature.profile.presentation.CreateUserProfilePresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = CreateUserProfilePresenterFactory::class)
public interface AppNestbridgeFeatureProfilePresentationCreateUserProfilePresenterFactory {
  @Provides
  @IntoSet
  public fun provideCreateUserProfilePresenterFactoryFactoryMultibinding(createUserProfilePresenterFactory: CreateUserProfilePresenterFactory): Presenter.Factory = createUserProfilePresenterFactory
}
